import type { UserOverridesItemRequest } from 'js/src/client';
import type { UserOverrides } from 'js/src/data/user-overrides';
import { DEFAULT_USER_OVERRIDES } from 'js/src/data/user-overrides';
import type { RootState } from 'js/src/libs/RootState';

export function getUserOverrides(state: RootState): UserOverrides {
    return state.undoable.present.user_overrides;
}

export function getSlideOverrides(state: RootState, sceneId: string): UserOverridesItemRequest {
    return getUserOverrides(state)[sceneId];
}

export function getAssetsWithTimesOverridden(state: RootState, sceneId: string): string[] {
    try {
        const overrides = getUserOverrides(state)[sceneId];
        return overrides?.asset_timing_overrides || [];
    } catch (error) {
        return [];
    }
}

export function isAssetTimingOverridden(
    state: RootState,
    sceneId: string,
    assetId: string,
): boolean {
    return getAssetsWithTimesOverridden(state, sceneId).includes(assetId);
}

export function isTextPositionUserOverridden(state: RootState, sceneId: string): boolean {
    try {
        return (
            getUserOverrides(state)[sceneId].text_position ?? DEFAULT_USER_OVERRIDES.TEXT_POSITION
        );
    } catch (error) {
        return DEFAULT_USER_OVERRIDES.TEXT_POSITION;
    }
}

export function isTextSizeUserOverridden(state: RootState, sceneId: string): boolean {
    try {
        return getUserOverrides(state)[sceneId].text_size ?? DEFAULT_USER_OVERRIDES.TEXT_SIZE;
    } catch (error) {
        return DEFAULT_USER_OVERRIDES.TEXT_SIZE;
    }
}

export function isTextAlignmentUserOverridden(state: RootState, sceneId: string): boolean {
    try {
        return (
            getUserOverrides(state)[sceneId].text_alignment ?? DEFAULT_USER_OVERRIDES.TEXT_ALIGNMENT
        );
    } catch (error) {
        return DEFAULT_USER_OVERRIDES.TEXT_ALIGNMENT;
    }
}

export function isSceneDurationUserOverridden(state: RootState, sceneId: string): boolean {
    try {
        return getUserOverrides(state)[sceneId].duration ?? DEFAULT_USER_OVERRIDES.DURATION;
    } catch (error) {
        return DEFAULT_USER_OVERRIDES.DURATION;
    }
}

export function isCropUserOverridden(state: RootState, sceneId: string): boolean {
    try {
        return (
            getUserOverrides(state)[sceneId].background_transform ??
            DEFAULT_USER_OVERRIDES.BACKGROUND_TRANSFORM
        );
    } catch (error) {
        return DEFAULT_USER_OVERRIDES.BACKGROUND_TRANSFORM;
    }
}

export function isKenburnUserOverridden(state: RootState, sceneId: string): boolean {
    try {
        return (
            getUserOverrides(state)[sceneId].background_animation ??
            DEFAULT_USER_OVERRIDES.BACKGROUND_ANIMATION
        );
    } catch (error) {
        return DEFAULT_USER_OVERRIDES.BACKGROUND_ANIMATION;
    }
}

export function isBrightnessUserOverridden(state: RootState, sceneId: string): boolean {
    try {
        return getUserOverrides(state)[sceneId].brightness ?? DEFAULT_USER_OVERRIDES.BRIGHTNESS;
    } catch (error) {
        return DEFAULT_USER_OVERRIDES.BRIGHTNESS;
    }
}
